/**
 * @generated SignedSource<<d427d37f8319e132825d140a7fcd59f9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { UpdatableFragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardColumnOld_updatable$data = {
  collapsed: boolean | null | undefined;
  readonly " $fragmentType": "BoardColumnOld_updatable";
};
export type BoardColumnOld_updatable$key = {
  readonly " $data"?: BoardColumnOld_updatable$data;
  readonly $updatableFragmentSpreads: FragmentRefs<"BoardColumnOld_updatable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardColumnOld_updatable",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "collapsed"
    }
  ],
  "type": "JiraBoardViewColumn",
  "abstractKey": "__isJiraBoardViewColumn"
};

(node as any).hash = "35bb817a87f1857589edac39e63233f7";

export default node;
